import React from 'react';
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';
import OrderCardAwards from '../Award/OrderCardAwards';
import SectionTitle from '../../SectionTitle';

const MenuContracts = (props) => {
  const { device, history } = props;
  const { screenSize } = device;
  const { t } = useTranslation('contracts');

  return (
    <div className={`${styles[screenSize]} ${styles.menuContracts}`}>
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />

      <div className={`${styles.menu} ${styles[screenSize]}`}>
        <div
          className={`${styles.card} ${styles[screenSize]}`}
          onClick={() => history.push('/cart/consultancy/contractUS')}>
          <OrderCardAwards>
            <div className={styles.title}>
              <div className={styles.image}>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/contracts/usa-icon-contrato.png`}
                  alt=''
                  className={styles.imageCountry}
                />
              </div>
              <div className={styles.titleBlue}>
                {t('usa')} <br />
                <label className={styles.subtitle}>{t('option')}</label>
              </div>
            </div>
            <div className={styles.menu}>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/contracts/contrato.png`}
                alt=''
                className={styles.imageContract}
              />
            </div>
          </OrderCardAwards>
        </div>

        <div
          className={`${styles.card} ${styles[screenSize]}`}
          onClick={() => history.push('/cart/consultancy/contractsMX')}>
          <OrderCardAwards>
            <div className={styles.title}>
              <div className={styles.image}>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/contracts/mexico-icon-contrato.png`}
                  alt=''
                  className={styles.imageCountry}
                />
              </div>
              <div className={styles.titleBlue}>
                {t('mx')}
                <br />
                <label className={styles.subtitle}>{t('option')}</label>
              </div>
            </div>
            <div className={styles.menu}>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/contracts/contrato.png`}
                alt=''
                className={styles.imageContract}
              />
            </div>
          </OrderCardAwards>
        </div>
      </div>
    </div>
  );
};

export default MenuContracts;
